import { Component, Input } from "@angular/core";

export enum ProgressBarStyle {
    Normal,
    Warn,
    Warn2,
    Warn3,
    Warn4,
    Alert,
    Alert2,
    Alert3,
    Alert4
}

@Component({
    selector: 'progress-bar',
    templateUrl: './progressBar.component.html',
    standalone: false
})
export class ProgressBarComponent {
    public progressBarStyle= ProgressBarStyle;
    @Input() public min: number = 0;
    @Input() public max: number = 100;
    @Input() public value: number;
    @Input() public text: string;
    @Input() public style: ProgressBarStyle = ProgressBarStyle.Normal;
}